var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusyroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 26.9833H14.5C14.0856 26.9833 13.5 27.5884 13.5 28.0166V29.05H3V18.975C3 18.5468 2.66438 18.2 2.25 18.2H0.75C0.335625 18.2 0 18.5468 0 18.975V36.025C0 36.4531 0.335625 36.7999 0.75 36.7999H2.25C2.66438 36.7999 3 36.4531 3 36.025V33.7H27V36.025C27 36.4531 27.3356 36.7999 27.75 36.7999H29.25C29.6644 36.7999 30 36.4531 30 36.025V30.0833C30 27.0869 27.3997 26.9833 24.5 26.9833Z",
    fill: "#168AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusyroom);
export default __webpack_public_path__ + "static/media/busyroom.0d3e11abccc39cd7d29d6ae7a640dfaf.svg";
export { ForwardRef as ReactComponent };